// main entry point


// get styles
// import './sass/css-variables.scss'
import './sass/main.scss'

// get scripts
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

// loads the Icon plugin
UIkit.use(Icons);
window.UIkit = UIkit;

import './js/scripts.js'


